/*
* Broadcast Theme - custom accessibility patches
* Added 2026-09-03 as part of a WCAG 2.1 AA remediation pass.
* Loaded from snippets/loading.liquid (renders on every page).
* Each block notes the WCAG success criterion it addresses.
* Safe to remove: delete the script tag at the bottom of
* snippets/loading.liquid and this file stops running.
*/

(function () {
  'use strict';

  /* ------------------------------------------------------------------
   * 1. WCAG 2.1.1 Keyboard (Level A) - the main homepage defect.
   * The homepage collection tabs are <li role="button" tabindex="0">.
   * They are focusable and announced as buttons, but the theme only
   * binds a click handler, so Enter does nothing and Space scrolls the
   * page. Native buttons fire click on Enter/Space automatically;
   * elements given role="button" must do it themselves.
   * Forwarding to .click() reuses the theme's existing handler, so this
   * keeps working if the tab logic changes on a theme update.
   * ---------------------------------------------------------------- */
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter' && event.key !== ' ' && event.key !== 'Spacebar') return;
    var el = event.target;
    if (!el || !el.getAttribute) return;
    if (el.getAttribute('role') !== 'button') return;
    var tag = el.tagName;
    if (tag === 'A' || tag === 'BUTTON' || tag === 'INPUT' ||
        tag === 'SELECT' || tag === 'TEXTAREA') return;
    event.preventDefault();
    el.click();
  });

  /* ------------------------------------------------------------------
   * 2. WCAG 2.4.7 Focus Visible (Level AA).
   * Broadcast gates all focus styling behind body.is-focused, e.g.
   *   body.is-focused .variant-input:focus + .variant__button-label
   * An earlier inline script in theme.liquid sets 'keyboard-nav'
   * instead, which the stylesheet never references, so the theme's
   * focus indicators never activate. Setting the class the CSS
   * actually looks for turns them back on.
   * ---------------------------------------------------------------- */
  document.addEventListener('keydown', function (event) {
    if (event.key === 'Tab') {
      document.body.classList.add('keyboard-nav');
      document.body.classList.add('is-focused');
    }
  });
  document.addEventListener('mousedown', function () {
    document.body.classList.remove('is-focused');
  });

  /* ------------------------------------------------------------------
   * 3. WCAG 1.3.1 Info and Relationships (Level A).
   * theme.liquid wraps footer sections in an outer <footer> and
   * group-footer renders its own <footer> inside it, producing two
   * nested contentinfo landmarks with identical names. Marking the
   * outer one presentational removes the duplicate without touching
   * markup or CSS.
   * ---------------------------------------------------------------- */
  function dedupeFooterLandmark() {
    var outer = document.querySelector('footer.footer-sections');
    if (outer && outer.querySelector('footer')) {
      outer.setAttribute('role', 'presentation');
    }
  }

  /* ------------------------------------------------------------------
   * 4. WCAG 2.1.1 Keyboard (Level A).
   * Horizontally scrolling regions have no focusable children, so a
   * keyboard user cannot scroll them. On the homepage that region is
   * 1372px wide inside a 502px window. Making the container focusable
   * lets arrow keys scroll it. Only applied when it actually
   * overflows, so we never add a pointless tab stop.
   * ---------------------------------------------------------------- */
  function makeScrollersReachable() {
    var selectors = ['.grid--mobile-slider', '.video-list-inner', '.multicolumn'];
    selectors.forEach(function (selector) {
      Array.prototype.forEach.call(document.querySelectorAll(selector), function (el) {
        if (el.hasAttribute('tabindex')) return;
        if (el.scrollWidth <= el.clientWidth + 4) return;
        var style = window.getComputedStyle(el);
        if (style.overflowX !== 'auto' && style.overflowX !== 'scroll') return;
        el.setAttribute('tabindex', '0');
        if (!el.getAttribute('aria-label') && !el.getAttribute('aria-labelledby')) {
          el.setAttribute('role', 'group');
          el.setAttribute('aria-label',
            'Scrollable content - use the left and right arrow keys to scroll');
        }
      });
    });
  }

  /* ------------------------------------------------------------------
   * 5. WCAG 2.2.2 Pause, Stop, Hide (Level A).
   * Hero and product videos autoplay on a loop with no pause control.
   * A visible pause button is the complete fix, but honouring the
   * visitor's own OS "reduce motion" setting covers the users this
   * criterion protects and costs nothing for everyone else.
   * Walks shadow roots, because the shoppable video app renders its
   * <video> elements inside a custom element.
   * ---------------------------------------------------------------- */
  function collectVideos(root, found) {
    Array.prototype.forEach.call(root.querySelectorAll('*'), function (el) {
      if (el.tagName === 'VIDEO') found.push(el);
      if (el.shadowRoot) collectVideos(el.shadowRoot, found);
    });
    return found;
  }

  function honourReducedMotion() {
    if (!window.matchMedia) return;
    if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    collectVideos(document, []).forEach(function (video) {
      if (!video.autoplay && !video.loop) return;
      video.removeAttribute('autoplay');
      video.removeAttribute('loop');
      video.setAttribute('controls', 'controls');
      try { video.pause(); } catch (e) { /* not playing yet */ }
    });
  }

  /* ---------------------------------------------------------------- */

  function applyPatches() {
    dedupeFooterLandmark();
    makeScrollersReachable();
    honourReducedMotion();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyPatches);
  } else {
    applyPatches();
  }

  window.addEventListener('load', function () {
    applyPatches();
    setTimeout(applyPatches, 2000);
  });

  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(makeScrollersReachable, 250);
  });
})();